import { IBasicOrderInfo, OrderTypes } from './Types';

export function isPhotoOrder(order: IBasicOrderInfo): boolean {
    return Boolean(order) && (order.orderType & OrderTypes.photo) !== 0;
}

export function isDigitalStylingOrder(order: IBasicOrderInfo): boolean {
    return Boolean(order) && (order.orderType & OrderTypes.digitalStyling) !== 0;
}

export function isBookableOrder(order: IBasicOrderInfo): boolean {
    return Boolean(order) && (order.orderType & OrderTypes.bookable) !== 0;
}
